import { render, staticRenderFns } from "./ChatBoxTracking.vue?vue&type=template&id=bbc0da8e&scoped=true&"
import script from "./ChatBoxTracking.vue?vue&type=script&lang=js&"
export * from "./ChatBoxTracking.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxTracking.vue?vue&type=style&index=0&id=bbc0da8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc0da8e",
  null
  
)

export default component.exports